import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable';
import moment from 'moment';
import { amPmTimeFormat, formatNumberWithCommas, formattedDate } from './index';
import { logo } from "../constant";

// Add status mapping
const getStatusLabel = (statusId) => {
  switch (statusId) {
    case 1:
      return 'Pending';
    case 2:
      return 'Confirmed';
    case 3:
      return 'Cancelled';
    case 4:
      return 'Completed';
    default:
      return 'Unknown';
  }
};

// Helper to remove HTML and special characters
const cleanText = (text) => {
  if (text === null || text === undefined) return '';
  return String(text).replace(/,/g, ' ').replace(/\n/g, ' ');
};

// Update exportBookingsToExcel to use the direct CSV approach
export const exportBookingsToExcel = (bookings) => {

  
  try {
    // Create CSV content with headers
    const csvContent = [
      // CSV headers - maintain the existing field structure
      [
        "Booking ID",
        "Date",
        "Time",
        "Duration",
        "Name",
        "Location", 
        "Court",
        "Gross Amount",
        "Discount Amount",
        "Net Amount",
        "Collected Amount",
        "Status",
      ].join(","),

      // CSV rows
      ...bookings.map((booking) =>
        [
          booking?.bookingNo?.split("-")?.slice(1).join("-") || "--",
          moment(booking?.bookingDate).format("DD-MMM-YY"),
          `${amPmTimeFormat(booking?.bookingStartTime)} - ${amPmTimeFormat(booking?.bookingEndTime)}`,
          `${findDifferenceBetweenTwoTimes(booking?.bookingStartTime, booking?.bookingEndTime)} hrs`,
          booking?.bookingPlayers?.find((data) => data?.isPrimary)?.playerFullName || "--",
          booking?.locationName || "--",
          booking?.courtName || "--",
          booking?.bookingGrossAmount || 0,
          booking?.bookingDiscountAmount || 0,
          booking?.bookingNetAmount || 0,
          booking?.bookingCollectedAmount || 0,
          getBookingStatusText(booking?.bookingStatusId) || "--",
        ].join(",")
      ),
    ].join("\n");

    // Create and download file
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `bookings_${moment().format("YYYY-MM-DD")}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error exporting to Excel:", error);
  }
};

// Helper function to find the difference between two times in hours
export const findDifferenceBetweenTwoTimes = (startTime, endTime) => {
  // Specify the format when parsing time strings
  const momentStartTime = moment(startTime, "HH:mm:ss");

  let momentEndTime;
  if (endTime === "00:00:00") {
    momentEndTime = moment("23:59:59", "HH:mm:ss");
  } else {
    momentEndTime = moment(endTime, "HH:mm:ss");
  }

  // Check if both moment objects are valid
  if (!momentStartTime.isValid() || !momentEndTime.isValid()) {
    return 0;
  }

  const diffInMinutes = momentEndTime.diff(momentStartTime, "minutes");
  const diffInHours = Math.round(diffInMinutes) / 60;
  return diffInHours;
};

export const convertUtcToLocalTime = (utcTimeString) => {
  console.log("Utc Time", utcTimeString);
  const utcTime = moment.utc(utcTimeString);
  // Convert to local timezone
  const localMoment = utcTime.local();
  console.log("Local Time", localMoment);
  return localMoment;
};
// Helper function to get booking status text
const getBookingStatusText = (statusId) => {
  switch (statusId) {
    case 1:
      return "Confirmed";
    case 2:
      return "Canceled";
    case 3:
      return "Pending";
    default:
      return "Unknown";
  }
}; 